import { render, staticRenderFns } from "./SysMonitor.vue?vue&type=template&id=473b0abe&"
import script from "./SysMonitor.vue?vue&type=script&lang=js&"
export * from "./SysMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports